export default Object.freeze({
  Corporación: 1,
  EspecialistaDEPR: 2,
  EspecialistaRempro: 3,
});
